import React from "react";
import { X, CalendarIcon, Sparkles } from "lucide-react";
import { ScheduleItem } from "../types";
import { TYPE_COLORS } from "../constants";
import { getDaysDiff, getDayConfig } from "../utils";

interface PlanningCellDetailModalProps {
  data: { teacher: string, date: Date, items: ScheduleItem[] } | null;
  onClose: () => void;
}

const PlanningCellDetailModal: React.FC<PlanningCellDetailModalProps> = ({ data, onClose }) => {
  if (!data) return null;
  const dateStr = `${data.date.getMonth() + 1}月${data.date.getDate()}日`;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity animate-in fade-in duration-200" onClick={onClose}></div>
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden animate-in fade-in zoom-in-95 duration-200 flex flex-col">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between bg-gray-50">
           <div><h3 className="text-lg font-bold text-gray-800">{data.teacher}</h3><p className="text-xs text-gray-500 font-medium flex items-center gap-1.5 mt-0.5"><CalendarIcon size={12} />{dateStr} · 共 {data.items.length} 个重叠班次</p></div>
           <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200 text-gray-400 hover:text-gray-600 transition"><X size={18} /></button>
        </div>
        <div className="p-4 space-y-3 max-h-[60vh] overflow-y-auto">
           {data.items.map((item) => {
              const diffDays = getDaysDiff(item.startDate, data.date);
              const dayCfg = getDayConfig(item.type, diffDays, false, false);
              const typeColor = TYPE_COLORS[item.type] || { bg: 'bg-gray-500', text: 'text-gray-600', label: item.type };
              return (
                <div key={item.id} className="border border-gray-200 rounded-lg p-3 hover:border-blue-300 transition-colors bg-white shadow-sm">
                   <div className="flex items-center justify-between mb-2">
                      <span className={`text-[10px] font-bold px-2 py-0.5 rounded text-white ${typeColor.bg}`}>{typeColor.label}</span>
                      <span className="text-xs text-gray-400 font-mono">{item.startDate.getMonth()+1}.{item.startDate.getDate()} 开营</span>
                   </div>
                   <div className="font-bold text-gray-800 mb-1">{item.groupCode}</div>
                   <div className="text-xs text-blue-600 font-medium bg-blue-50 px-2 py-1 rounded inline-block">{dayCfg.title}</div>
                   {item.isPredicted && <div className="mt-2 text-[10px] text-indigo-500 font-bold flex items-center gap-1"><Sparkles size={10} /> 智能预测排期</div>}
                </div>
              );
           })}
        </div>
      </div>
    </div>
  );
};

export default PlanningCellDetailModal;
